import { render, staticRenderFns } from "./SearchButton.vue?vue&type=template&id=1356a0cf&scoped=true&"
import script from "./SearchButton.vue?vue&type=script&lang=js&"
export * from "./SearchButton.vue?vue&type=script&lang=js&"
import style0 from "./SearchButton.vue?vue&type=style&index=0&id=1356a0cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1356a0cf",
  null
  
)

export default component.exports